import { render, staticRenderFns } from "./PredefinedStocksCreate.vue?vue&type=template&id=342880fa&"
import script from "./PredefinedStocksCreate.vue?vue&type=script&lang=js&"
export * from "./PredefinedStocksCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pzuber/Desktop/Repozytoria/HairTalk/hairtalk/HairTalk/HT_Portal_VUE/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCardActions,VCol,VContainer,VForm,VIcon,VRow,VSnackbar,VTextField})
